import React, { useContext } from 'react'
import PropTypes from 'prop-types'

import Icon from '@mdi/react'
import { mdiPencilOutline, mdiFileDocumentBoxOutline } from '@mdi/js'

import PanelContext from '../../../../../State/Panel/Context'
import TemplateContext from '../../../../../State/Templates/Context'

const Details = ({ row, isDefaultTemplate }) => {
  const { actions: { changeView } } = useContext(PanelContext)
  const { actions: { setSelectedAttribute } } = useContext(TemplateContext)
  const { original } = row

  const getPanelType = () => {
    if (isDefaultTemplate) {
      return 'attributes/view'
    }

    switch (true) {
      case original.type === 'inputOutput':
        return 'attributes/editIO'
      default:
        return 'attributes/edit'
    }
  }

  const handleClick = () => {
    const panelView = getPanelType()
    setSelectedAttribute(original)
    changeView(panelView)
  }

  return (
    <button
      type="button"
      title={isDefaultTemplate ? 'Read Template' : 'Edit Template'}
      data-testid={`templates-${isDefaultTemplate ? 'read' : 'edit'}-button-${original.bacnetId}`}
      onClick={handleClick}
    >
      <Icon path={isDefaultTemplate ? mdiFileDocumentBoxOutline : mdiPencilOutline} size={1} />
    </button>
  )
}

Details.propTypes = {
  row: PropTypes.object.isRequired,
  isDefaultTemplate: PropTypes.bool.isRequired
}

export default Details
